module.exports = __webpack_public_path__ + "img/motorcycle-orange.159d9a29.svg";